import Reveal from '@/pages/zz-review/components/Reveal';

const fields = [
  { name: '子場', desc: '個人生命實踐的起點' },
  { name: '母場', desc: '關係與社群的孕育' },
  { name: '父場', desc: '文明與治理的承擔' },
];

export default function AxionUtopiaSection() {
  return (
    <section id="axion" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-12 md:mb-14">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              Axion Utopia
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              子場・母場・父場
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
              生命實踐的場域，由內而外逐層展開，形成可以承擔、可以共建的文明架構。
            </p>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {fields.map((field) => (
              <div
                key={field.name}
                className="rounded-lg border border-background-200/70 bg-background-100 px-5 py-6 text-center"
              >
                <p
                  className="text-lg md:text-xl text-foreground-900 font-medium mb-1"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {field.name}
                </p>
                <p className="text-sm text-foreground-500">{field.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={100}>
          <p className="text-center text-xs text-foreground-400 mt-8">Coming Soon</p>
        </Reveal>
      </div>
    </section>
  );
}